export default class Popup {
    constructor(selector) {
        this.links = document.querySelectorAll(selector)
        this.openedPopup = null
        this.setListeners()
    }

    open(link, highlight) {
        let shouldOpen = this.openedPopup !== document.querySelector(link)

        if (this.openedPopup) {
            this.close(this.openedPopup)
        }
        if (shouldOpen) {
            document.body.classList.add("popup-opened")
            
            let popup = document.querySelector(link)
            if (!popup) {
                console.error(link, " не найден!")
                return
            }

            //Для попапов на весь экран(с байком и магазином)
            if(popup.classList.contains('popup--bike') || popup.classList.contains('popup--store')  ) {
                document.body.classList.add("popup--fullscreen")
                //Закрываем меню если нажали на попап
                if(document.body.classList.contains('mobilemenu-opened')) {
                    document.querySelector('.header__menu').click()
                }
                //Отдельная кнопка закрытия в хедере
                document.querySelector('.header__close')?.addEventListener('click', function() {
                    window.popup.close(popup)
                })
            }

            this.openedPopup = popup
            popup.classList.add("opening")
            setTimeout(() => {
                popup.classList.remove("opening")
                popup.classList.add("opened")
            }, 50)
            //Подсвечиваем ссылку на которую был открыт попап
            highlight?.classList.add('highlight')

            // Клик по классу custom-close, так же закроет попап
            popup.addEventListener("mousedown", (e) => {
                if (e.target.classList.contains("popup") || e.target.classList.contains("popup__close") || e.target.classList.contains("custom-close")) {
                    this.close(popup)
                }
            })
        }
    }

    close(popup) {
        popup.classList.add("closing")
        
        if(popup.classList.contains('popup--video')) {
            popup.querySelector('video').pause()
        }

        if(popup.classList.contains('popup--bike') || popup.classList.contains('popup--store')  ) {
            document.body.classList.remove("popup--fullscreen")
        }

        document.querySelector('.highlight')?.classList.remove('highlight')

        setTimeout(() => {
            popup.classList.remove("closing")
            popup.classList.remove("opened")
            document.body.classList.remove("popup-opened")
        }, 300)
        this.openedPopup = null
        popup.removeEventListener("mousedown", close)
        
    }

    setListeners() {
        if (this.links.length < 1) return
        // Слушатель на ссылки
        this.links.forEach((link) => {
            link.addEventListener("click", () => {
                this.open(link.getAttribute("data-popup"), link)
            })
        })
    }
}
